/**
 * Reorder helpers for CV editor lists (experience, education, tags).
 */

/**
 * Move one item to a new index. Out-of-range indexes leave the list unchanged.
 *
 * @param {Array} list
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {Array}
 */
export const moveArrayItem = (list, fromIndex, toIndex) => {
  if (!Array.isArray(list) || list.length < 2) {
    return Array.isArray(list) ? [...list] : [];
  }
  const from = Number(fromIndex);
  const to = Number(toIndex);
  if (
    !Number.isInteger(from)
    || !Number.isInteger(to)
    || from === to
    || from < 0
    || to < 0
    || from >= list.length
    || to >= list.length
  ) {
    return [...list];
  }
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
};
